import CurriculumManager from '../lib/CurriculumManager';
import gameNames from '../../hub/data/GameIds';
import { STANDARD_ITEM_SETS_PER_LEVEL } from '../data/constants';

const curriculumManager = new CurriculumManager();
let standardSetIndex;

const initialState = {
  onboarding: {},
  mystery: '',
  standardSet: [],
  standardSetIndex: 0,
  practiceSet: [],
  standardIndex: 0,
  practiceIndex: 0,
  icons: [],
  answeredQuestionsCount: 0,
};

/**
 * Really basic curriculum reducer, nothing super special here
 *
 * Quick Ref:
 * LOAD_CURRICULUM
 * INCREMENT_STANDARD_INDEX
 * INCREMENT_STANDARD_SET_INDEX
 * INCREMENT_PRACTICE_INDEX
 * LOAD_NEW_PRACTICE_SET
 * LOAD_NEW_LEVEL
 */
const curriculumReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.UNMASK_THAT) {
    return state;
  }

  let nextPracticeIndex = 0;
  if (state.practiceSet !== [] && state.practiceSet) {
    nextPracticeIndex = state.practiceIndex + 1 >= state.practiceSet.length
      ? 0
      : state.practiceIndex + 1;
  }

  switch (action.type) {
    // Loads a curriculum with level 1 as the default level,
    // gets a standardSet, practiceSet, mystery, and icons
    case 'LOAD_CURRICULUM':
      curriculumManager.init(action.curriculumJson);
      curriculumManager.populateOnboarding();
      curriculumManager.populateStandardSets(1);
      curriculumManager.populatePracticeSet(1);
      return {
        ...state,
        onboarding: curriculumManager.getOnboarding(),
        mystery: curriculumManager.getMystery(),
        standardSet: curriculumManager.getStandardSet(state.standardSetIndex),
        practiceSet: curriculumManager.getPracticeSet(),
        icons: curriculumManager.getIcons(),
      };
    case 'INCREMENT_STANDARD_INDEX':
      return {
        ...state,
        standardIndex: state.standardIndex + 1,
      };
    case 'INCREMENT_ANSWERED_QUESTIONS_COUNT':
      return {
        ...state,
        answeredQuestionsCount: state.answeredQuestionsCount + 1,
      };
    case 'INCREMENT_STANDARD_SET_INDEX':
      // It doesn't make sense to set index to be greater than the number of avail items
      // so make sure we reset to 0 instead of increasing too high
      standardSetIndex =
        state.standardSetIndex + 1 >= STANDARD_ITEM_SETS_PER_LEVEL
          ? 0
          : state.standardSetIndex + 1;

      return {
        ...state,
        standardSetIndex,
        standardSet: curriculumManager.getStandardSet(standardSetIndex),
      };
    case 'RESET_STANDARD_SET_INDEX':
      return {
        ...state,
        standardSetIndex: 0,
      };
    case 'INCREMENT_PRACTICE_INDEX':
      // It doesn't make sense to set practice index to be greater than the number of avail items
      // so make sure we reset to 0 instead of increasing too high
      return {
        ...state,
        practiceIndex: nextPracticeIndex,
      };
    case 'CLEAR_PRACTICE_INDEX':
      return {
        ...state,
        practiceIndex: 0,
      };
    // Completely exchanges the curriculum data for a new level
    case 'LOAD_NEW_LEVEL':
      curriculumManager.populateStandardSets(action.level);
      curriculumManager.populatePracticeSet(action.level);
      return {
        ...state,
        mystery: curriculumManager.getMystery(),
        standardSet: curriculumManager.getStandardSet(state.standardSetIndex),
        practiceSet: curriculumManager.getPracticeSet(),
        standardIndex: 0,
        icons: curriculumManager.getIcons(),
        practiceIndex: state.practiceIndex % 2 !== 0 ?
          nextPracticeIndex :
          state.practiceIndex,
        answeredQuestionsCount: 0,
      };
    default:
      return state;
  }
};

export default curriculumReducer;
